import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }   from '@angular/forms'; // <-- NgModel lives here
import { ConfigurationComponent } from './configuration.component';
import { NglModule } from 'ng-lightning';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

import { AlertModule } from '../../common/component/alert/alert.module';

import { ConfigurationKeywordModule } from '../../common/component/configuration-keyword/configuration-keyword.module'

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NglModule,
        AlertModule,
        DropDownsModule,
        ConfigurationKeywordModule
    ],
    declarations: [ConfigurationComponent],
    exports: [ConfigurationComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ConfigurationModule { }
